module.exports = __webpack_public_path__ + "img/9788991684485.5736f231.jpg";